<template>
  <div class="app-wrapper" :class="classObj">
    <sidebar class="sidebar-container" :user="user"></sidebar>
    <div class="main-container">
      <navbar :user="user"></navbar>
      <app-main></app-main>
    </div>
  </div>
</template>

<script>
import { Navbar, Sidebar, AppMain } from './components'
// import ResizeMixin from './mixin/ResizeHandler'
import { personalInfo } from '@/api/personal'

export default {
  name: 'layout',
  components: {
    Navbar,
    Sidebar,
    AppMain
  },
  // mixins: [ResizeMixin],
  data() {
    return {
      user: null
    };
  },
  created() {
    new personalInfo().success(response=>{
      this.user=response;
    }).run();
  },
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar
    },
    device() {
      return this.$store.state.app.device
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      }
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "src/styles/mixin.scss";
  .app-wrapper {
    @include clearfix;
    position: relative;
    height: 100%;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/Layout.vue